/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FAnonymousType91
 */
export interface FAnonymousType91 {
    /**
     * 
     * @type {number}
     * @memberof FAnonymousType91
     */
    measurementId?: number;
}

/**
 * Check if a given object implements the FAnonymousType91 interface.
 */
export function instanceOfFAnonymousType91(value: object): value is FAnonymousType91 {
    return true;
}

export function FAnonymousType91FromJSON(json: any): FAnonymousType91 {
    return FAnonymousType91FromJSONTyped(json, false);
}

export function FAnonymousType91FromJSONTyped(json: any, ignoreDiscriminator: boolean): FAnonymousType91 {
    if (json == null) {
        return json;
    }
    return {
        
        'measurementId': json['measurementId'] == null ? undefined : json['measurementId'],
    };
}

export function FAnonymousType91ToJSON(json: any): FAnonymousType91 {
    return FAnonymousType91ToJSONTyped(json, false);
}

export function FAnonymousType91ToJSONTyped(value?: FAnonymousType91 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'measurementId': value['measurementId'],
    };
}

